// Core
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// Services
import { PopupManager } from './popup.service';
import { PopupOptions } from './popup.options';

// Components
import { PopupComponent } from './popup.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PopupComponent],
  entryComponents: [PopupComponent]
})
export class PopupBoxesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PopupBoxesModule,
      providers: [PopupManager, PopupOptions]
    };
  }
}
